import { environment } from "src/environments/environment"
import { BusinessPorting } from "./BusinessPorting.interface"

export const INITIAL_BUSINESS_PORTING: BusinessPorting = (environment.mock && environment.mockBusinessPorting) ?  {
  porting: true,
  numbersCount: 2,
  numbers: ["12345", "67890", "", "", "", "", "", "", "", ""],
  provider: "Telekom Deutschland GmbH"
} : {
  porting: false,
  numbersCount: 1,
  numbers: ["", "", "", "", "", "", "", "", "", ""],
  provider: ""
}
